export const scmNameHash: {
  [key: string]: string;
} = {
  Portfolio: "Survey",
  Parties: "Data Forms",
};
